import styled from 'styled-components';

export const FileUploadButton = styled.button`
  display: block;
  background: none;
  border: none;
  color: var(--color-brand-secondary-sapphire);
  font: var(--font-regular-14pt-normal);
  font-weight: var(--typography-small-13pt-semibold-font-weight);
  cursor: pointer;
`;

type StyledFileUploaderContainerProps = {
  $maxWidth?: string;
};

export const FileUploaderContainer = styled.div<StyledFileUploaderContainerProps>`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border-radius: 6px;
  background-color: var(--color-gray-10);
  grid-column: 2 / span 3;
  padding: 22px 61.5px;
  max-width: ${({ $maxWidth }) => $maxWidth ?? '536px'};
`;
export const FileUploaderMessage = styled.p<{ hasHeader?: boolean }>`
  margin-top: ${({ hasHeader }) => (hasHeader ? `var(--sizes-30)` : `var(--sizes-40)`)};
  margin-bottom: var(--sizes-40);
  color: var(--color-gray-70);
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.005em;
  font-weight: var(--typography-small-13pt-normal-font-weight);
  width: 272px;
`;

export const IconFileUploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 65px;
  text-align: center;
  align-items: center;
  border-radius: 6px;
  border: 1px dashed var(--color-gray-40);
  background-color: var(--color-gray-10);
  height: 65px;
  justify-content: center;
`;
